/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_DownloadsInputs */

const en_public_downloads = /** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Downloads`)
};

const id_public_downloads = /** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduhan Publik`)
};

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const es_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const fr_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const de_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const ja_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const zh_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const ar_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const it_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const ru_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const pt_public_downloads = en_public_downloads;

/** @type {(inputs: Public_DownloadsInputs) => LocalizedString} */
const ko_public_downloads = en_public_downloads;

/**
* | output |
* | --- |
* | "Public Downloads" |
*
* @param {Public_DownloadsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const public_downloads = /** @type {((inputs?: Public_DownloadsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_DownloadsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_downloads(inputs)
	if (locale === "es") return es_public_downloads(inputs)
	if (locale === "fr") return fr_public_downloads(inputs)
	if (locale === "de") return de_public_downloads(inputs)
	if (locale === "ja") return ja_public_downloads(inputs)
	if (locale === "zh") return zh_public_downloads(inputs)
	if (locale === "ar") return ar_public_downloads(inputs)
	if (locale === "id") return id_public_downloads(inputs)
	if (locale === "it") return it_public_downloads(inputs)
	if (locale === "ru") return ru_public_downloads(inputs)
	if (locale === "pt") return pt_public_downloads(inputs)
	return ko_public_downloads(inputs)
});